// extracted by mini-css-extract-plugin
module.exports = {"root":"buttonConfirm_root__N-Ouv"};